var app = angular.module("leonardo");

var PropertyDeleteDialog = function($scope, $rootScope, FormErrorsService, PropertyService) {
  $scope.property = $scope.ngDialogData.property;
  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.property.remove().then(function() {
      PropertyService.updateCollection($scope.property, true);
      $rootScope.$broadcast('property:deleted', $scope.property);
      $scope.closeThisDialog();
    });
  };
};

app.controller('PropertyDeleteDialog', ['$scope', '$rootScope', 'FormErrorsService', 'PropertyService',
  PropertyDeleteDialog]);
